module.exports = __webpack_public_path__ + "static/media/gladiator.18e07c4f.png";